<div
  class="id-card-tilt flex flex-col first-line:items-center gap-4 aspect-[1.8] rounded-3xl border border-gray-200 bg-white overflow-hidden">
  <div class="flex flex-row flex-1 items-center gap-4 w-full p-6 pb-0">
    <div class="flex items-center justify-center size-20 rounded-lg bg-gray-100 overflow-hidden
    border border-gray-200">
      @if (faceId?.imageUrl) {
      <img [src]="ImageUtil.getImageSource(faceId.imageUrl)" alt="Face ID"
        class="w-full h-full object-cover saturate-0 contrast-100 brightness-150  rounded-lg" />
      } @else {
      <ion-icon name="person-circle-outline" size="large" class="text-gray-400"></ion-icon>
      }
    </div>
    <div class="flex flex-col flex-1 gap-2">
      <div class="font-semibold text-base text-gray-600">{{ fullName }}</div>
      <ion-skeleton-text class="w-[60px] h-2 bg-gray-100 rounded-full"></ion-skeleton-text>
      <ion-skeleton-text class="w-[100px] h-2 bg-gray-100 rounded-full"></ion-skeleton-text>
    </div>
  </div>
  <div class="w-full h-12 bg-gray-100 flex flex-row items-center justify-between px-6">
    <p class="text-base font-medium text-gray-500 m-0">xxxx xxxx xxxx</p>
    <div class="size-6 bg-gray-200 rounded-full"></div>
  </div>
</div>